import {useState} from "react";
import {withTranslation} from "react-i18next";
import {
    LogoutOutlined
} from '@ant-design/icons';

import "../ceiba.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'
import StepCeibaTwo from "./stepCeibaTwo";
import StepCeibaThree from "./stepCeibaThree";
import StepCeibaFour from "./stepCeibaFour";
import StepCeibaFive from "./stepCeibaFive";
import StepCeibaSix from "./stepCeibaSix";
import StepCeibaSeven from "./stepCeibaSeven";
import StepCeibaVideo from "./StepCeibaVideo";
import {xcService} from "../../../../_services/xcService";


function StepCeibaOne(props) {

    const {t, i18n} =props;
    const [step, setStep] = useState(1);
    const goTo = (number) => {

        setStep(number)
    }

    const saveGamed = () => {
        xcService.putToken("/v1/savegame", {quest: 'quest1'}).then( (data ) => {
            setStep(2);
        }).catch( (err) =>  setStep(2))


    }
    return (
<>
    {step === 1 &&

        <div className={"backGroundCeiba first"}>
            <div className={"wrapper boxed"}>
                <div className={"insideCeiba boxed"}>
                    <Button
                      onClick={() => history.push("/admin/assessment")}
                      className="primaryButton btn-icon-text" icon={<LogoutOutlined/>}>{t("exit")}</Button>
                </div>
                <div className={"initCeiba"}>
                    <h2 className={"title-xs"}>{t("ceiba.title")}</h2>
                    <h3>{t("ceiba.antes")} <strong>{t("ceiba.quequieres")}</strong></h3>
                    <div className={"content-cards"}>
                        <div className={"card"}>
                            <div className={"chooseOp"}>
                                <img src={"/assets/img/arbolverde.png"} onClick={() => history.push("/admin/assessment")}/>
                                <Button type={"primary"}
                                        onClick={() => saveGamed()}
                                        className="primaryButton">{t("ceiba.conocer")}</Button>
                            </div>
                        </div>
                        <div className={"card"}>
                            <div className={"chooseOp"}>
                                <img src={"/assets/img/goquestion.png"} onClick={() => history.push("/admin/start-ceiba")}/>
                                <Button
                                        onClick={() => history.push("/admin/ceiba-instructions")}
                                        className="primaryButton">{t("ceiba.ird")}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    {step === 2 &&
            <StepCeibaTwo goTo={goTo} />
    }
    {step === 3 &&
        <StepCeibaThree goTo={goTo} />
    }
    {step === 4 &&
        <StepCeibaFour goTo={goTo} />
    }
    {step === 5 &&
        <StepCeibaVideo goTo={goTo} />
    }
    {step === 6 &&
        <StepCeibaFive goTo={goTo} />
    }
    {step === 7 &&
        <StepCeibaSix goTo={goTo} />
    }

    {step === 8 &&
        <StepCeibaSeven goTo={goTo} />
    }
</>

    )
}

export default withTranslation()(StepCeibaOne);
